/**
 * The @api registry — every backend call goes through the KORM contract at
 * /api/crud/:Model. Add named entries for ergonomics; `crud` is the generic door.
 */
const stripModel = ({ model, ...rest }) => rest;

export default {
  login: (data) => ({ url: '/api/crud/User', method: 'POST', data: { action: 'login', data } }),
  logout: () => ({ url: '/api/crud/User', method: 'POST', data: { action: 'logout' } }),

  // Generic: fetchApi('crud', { model:'Bill', action:'list', where:{...}, data:{...} })
  crud: (body) => ({ url: `/api/crud/${body.model}`, method: 'POST', data: stripModel(body) }),
};
